//usei o acessoInformacao como base

import { apiSlice } from '../../../../app/apiSlice';
import configSiteUrls from '../../configs/configSiteUrls';
import { AcessoInformacao, AcessoInformacaoDTO, AcessoInformacaoList, AcessoInformacaoLogin, AcessoInformacaoLoginResponse, AcessoInformacaoRespostaDTO } from './types/AcessoInformacao';

const endpointPublicUrl = configSiteUrls.SITE_ACESSO_INFORMACAO_PUBLIC_EP;
const endpointtUrl = configSiteUrls.SITE_ACESSO_INFORMACAO_EP;

function addAcessoInformacao(obj: AcessoInformacaoDTO) {
  return {
    url: `${endpointPublicUrl}/create`,
    method: 'POST',
    body: obj
  };
}

function addAcessoInformacaoResposta(obj: AcessoInformacaoRespostaDTO) {
  return {
    url: `${endpointtUrl}/create`,
    method: 'POST',
    body: obj
  };
}

function getAcessoInformacaoByLogin(body: AcessoInformacaoLogin) {
  if (!body.login || !body.senha) {
    return {
      url: '', // URL vazia
      method: 'GET' // método inofensivo
    };
  }
  return {
    url: `${endpointPublicUrl}/login`,
    method: 'POST',
    body: body
  };
}

function getAcessoInformacaos({ search }: { search: string }) {
  return {
    url: `${endpointtUrl}/filter?search=${search}`,
    method: 'GET'
  };
}

function deleteAcessoInformacao({ id }: { id: string }) {
  return {
    url: `${endpointtUrl}/${id}`,
    method: 'DELETE'
  };
}
function getAcessoInformacao(id: string) {
  if (!id) {
    return {
      url: '',
      method: ''
    };
  }

  return {
    url: `${endpointtUrl}/${id}`,
    method: 'GET'
  };
}

export const acessoInformacaoApiSlice = apiSlice.injectEndpoints({
  endpoints: ({ query, mutation }) => ({
    getAcessoInformacaos: query<AcessoInformacaoList[], { search: string }>({
      //query: (id) => `${endpointPublicUrl}/ciencia/${id}`,
      query: getAcessoInformacaos,
      providesTags: ['AcessoInformacao']
    }),

    getAcessoInformacao: query<AcessoInformacao, string>({
      //query: (id) => `${endpointPublicUrl}/ciencia/${id}`,
      query: getAcessoInformacao,
      providesTags: ['AcessoInformacao']
    }),
    getAcessoInformacaoByLogin: mutation<AcessoInformacao, AcessoInformacaoLogin>({
      query: getAcessoInformacaoByLogin,
      invalidatesTags: ['AcessoInformacao']
    }),

    addAcessoInformacao: mutation<AcessoInformacaoLoginResponse, AcessoInformacaoDTO>({
      query: addAcessoInformacao,
      invalidatesTags: ['AcessoInformacao']
    }),
    addAcessoInformacaoResposta: mutation<AcessoInformacaoLoginResponse, AcessoInformacaoRespostaDTO>({
      query: addAcessoInformacaoResposta,
      invalidatesTags: ['AcessoInformacao']
    }),
    deleteAcessoInformacao: mutation<void, { id: string }>({
      query: deleteAcessoInformacao,
      invalidatesTags: ['AcessoInformacao']
    })
  })
});
export const { useGetAcessoInformacaosQuery, useGetAcessoInformacaoQuery, useAddAcessoInformacaoMutation, useDeleteAcessoInformacaoMutation, useGetAcessoInformacaoByLoginMutation, useAddAcessoInformacaoRespostaMutation } = acessoInformacaoApiSlice;
